module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-400italic.22e7b04e5f2a901d49d4d342315a715a.woff";